import { Box, Typography } from "@mui/material"
import { ReactComponent as Heart } from "static/svg/heart.svg"
import { EXPECTED_SYMPTOMS_COUNT } from "config/constants"
import useTranslation from "hooks/use_translation"

const AlertInfo = () => {
  const { anamnesis } = useTranslation()

  return (
    <Box sx={{ display: "flex", p: 2, backgroundColor: "#E0EBFF", borderRadius: "12px", mb: 2 }}>
      <Heart />
      <Typography variant="body2" sx={{ fontWeight: 500, ml: 1.5 }}>
        {anamnesis?.symptoms_hint_first} {EXPECTED_SYMPTOMS_COUNT} {anamnesis?.symptoms_hint_second}
      </Typography>
    </Box>
  )
}

export default AlertInfo
